import themeComponent, { themeGroupComponent } from '../components/themes/themeComponent'

export const importItemComponents = async (theme, items) =>
  (
    await Promise.all(
      items.map(async (item) => {
        try {
          const { component, group, reuseComponent } = await themeComponent(theme, item.type)
          return {
            item,
            component,
            group,
            reuseComponent, // if the exact same component was active previously, reuse it with new data
            key: item.id,
          }
        } catch {
          return null
        }
      })
    )
  ).filter((item) => item !== null)

export const groupItemComponents = async (theme, itemComponents) => {
  const groupComponentParts = groupBy(itemComponents, 'group')

  return await asyncFlatMap(Object.entries(groupComponentParts), async ([group, items]) => {
    if (!group || group === 'null') {
      return items
    }

    const { component: groupComponent, groupId } = await themeGroupComponent(theme, group)

    return {
      item: items,
      component: groupComponent,
      groupId,
      key: groupId,
    }
  })
}

const groupBy = (array, key) =>
  array.reduce((acc, item) => {
    const group = item[key]
    if (!acc[group]) {
      acc[group] = []
    }
    acc[group].push(item)
    return acc
  }, {})

const asyncFlatMap = async (array, callback) => {
  const promises = array.map(callback)
  const arrays = await Promise.all(promises)
  return arrays.flat()
}
